import React from "react";
import { Link } from "react-router-dom";
import "./button.css";

const Button = ({ children, onClick }) => {
  const handleClick = (event) => {
    event.preventDefault(); // デフォルトのフォーム送信をキャンセル
    onClick(); // 渡された onClick 関数を実行
  };

  return (
    <button onClick={handleClick}>
      <div className="button" onClick={onClick}>
        {children}
      </div>
    </button>
  );
};

export default Button;